import { Renderer } from "../renderers/renderer"
import { AddButton as Button } from "../../add-button"

export class EventRenderer extends Renderer {
  button(callback) {
    const button = new Button()
    callback.call(this, button)
    return button
  }

  get buttons() {
    if (this.node.disabled) {
      return []
    }

    const buttons = [
      this.button(button => {
        button.dataset.type = "child"
      })
    ]

    if (this.node.dataset.extendable === "true") {
      buttons.push(
        this.button(button => {
          button.dataset.type = "sibling"
          if (this.node.dataset.root === "true") {
            button.dataset.entryNode = "true"
          }
        })
      )
    } else if (this.node.dataset.extendable == "false") {
      buttons.push(
        this.button(button => {
          button.dataset.type = "sibling"
          button.dataset.extendable = false
          button.dataset.originalTitle = this.disabledTooltipText
        })
      )
    }

    return buttons
  }

  get text() {
    return this.node.dataset.name
  }

  get tooltipText() {
    if (this.node.disabled) {
      return ""
    }

    let prependText

    if (this.node.dataset.root === "true") {
      prependText = "Start this automation when"
    } else {
      prependText = "Jump to this point when"
    }

    if (this.node.dataset.type === "tag-added") {
      return `${prependText} <b>${this.text}</b> tag is added to the subscriber`
    } else if (this.node.dataset.type === "tag-removed") {
      return `${prependText} <b>${this.text}</b> tag is removed from the subscriber`
    } else if (this.node.dataset.type === "date-occurred") {
      return `Move all subscribers to this point when <b>${this.text.replace(
        "Date: ",
        ""
      )}</b> occurs`
    } else if (this.node.dataset.type === "subscriber-added") {
      return `Start this automation when the subscriber joins <b>${this.text}</b> form`
    } else if (this.node.dataset.type === "automation-added") {
      return `Start this automation when the subscriber is added from the <b>${this.text}</b> automation`
    } else if (this.node.dataset.type === "custom-field-changed") {
      return `Start this automation when the custom field <b>${this.text}</b>`
    } else if (
      this.node.dataset.type === "app-event-occurred" &&
      this.detail.app_removed
    ) {
      return "This app has been uninstalled or removed. This node will no longer function as expected."
    } else {
      return ""
    }
  }

  get disabledTooltipText() {
    if (this.node.disabled) {
      return ""
    }

    if (this.node.dataset.root === "true") {
      return "You can only add up to 5 items in a row. Use tags to merge multiple forms into one entry point."
    } else {
      return "You can only add up to 5 items in a row"
    }
  }
}
